import { useEffect, useRef, useSyncExternalStore } from 'react';
import {
  assinarAtalhos,
  empilharFechar,
  geracaoAtalhos,
  ligarAcao,
  ligarOuvinte,
  type Acao,
  type CamadaFechar
} from './atalhos';

/**
 * Redesenha quando o mapa muda ou o layout do teclado resolve.
 * O rótulo continua vindo de `rotuloTecla` / `teclaDe`.
 */
export function useAtalhos(): number {
  return useSyncExternalStore(assinarAtalhos, geracaoAtalhos, () => geracaoAtalhos());
}

export function useAtalho(acao: Acao, fn: () => void) {
  const fnRef = useRef(fn);
  fnRef.current = fn;
  useEffect(() => ligarAcao(acao, () => fnRef.current()), [acao]);
}

export function useFechar(
  fechar: () => void,
  opts?: { ativo?: boolean; modal?: boolean; comeSlots?: boolean; deixaPassar?: readonly Acao[] }
) {
  const fecharRef = useRef(fechar);
  fecharRef.current = fechar;
  const ativo = opts?.ativo ?? true;
  const modal = opts?.modal ?? false;
  const comeSlots = opts?.comeSlots ?? false;
  const passaKey = opts?.deixaPassar?.join(',') ?? '';
  useEffect(() => {
    if (!ativo) return;
    const camada: CamadaFechar = {
      fechar: () => fecharRef.current(),
      modal,
      comeSlots,
      deixaPassar: new Set(passaKey ? passaKey.split(',') as Acao[] : [])
    };
    return empilharFechar(camada);
  }, [ativo, modal, comeSlots, passaKey]);
}

export function useOuvinteAtalhos() {
  useEffect(() => { ligarOuvinte(); }, []);
}
